import { createFileRoute } from "@tanstack/react-router";

import { listPublicPackagesOptions } from "@/actions/coaching-package/handler";
import { listPublishedEssaysOptions } from "@/actions/essay/handler";
import { listActiveSlidesOptions } from "@/actions/hero-slide/handler";
import { listPublicProductsOptions } from "@/actions/product/handler";
import { LandingPage } from "@/components/landing-page";
import { seo } from "@/utils/seo";

export const Route = createFileRoute("/_app/")({
  ssr: true,
  loader: async ({ context }) => {
    // ensureQueryData: data'yı cache'e ekler, component render'da beklemez
    await Promise.allSettled([
      context.queryClient.ensureQueryData(listActiveSlidesOptions()),
      context.queryClient.ensureQueryData(listPublishedEssaysOptions()),
      context.queryClient.ensureQueryData(listPublicPackagesOptions()),
      context.queryClient.ensureQueryData(listPublicProductsOptions()),
    ]);
  },
  head: () => ({
    meta: seo({
      title: "AtalayTheCoach | Alican Atalay ile Powerlifting Koçluğu",
      description:
        "Alican Atalay ile profesyonel powerlifting koçluğu, antrenman programları ve güç sporları üzerine derinlemesine içerikler. Performansınızı bir üst seviyeye taşıyın.",
      canonical: "https://atalaythecoach.com",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "AtalayTheCoach",
          url: "https://atalaythecoach.com",
          description:
            "Alican Atalay ile profesyonel powerlifting koçluğu ve antrenman programları.",
          author: {
            "@type": "Person",
            name: "Alican Atalay",
          },
        }),
      },
    ],
  }),
  component: HomeComponent,
});

function HomeComponent() {
  return <LandingPage />;
}
